import { useEffect, useState } from 'react';
import css from './ProgramOverview.module.css';

import * as programServices from '../../../../../services/programServices';

import Table from '../../../_common/data/Table';
import ModalForm from '../../../_common/ModalForm';
// import AddNewStudent from './AddNewStudent';

function ProgramOverview() {
    const [programs, setProgram] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        let page;
        programServices
            .getAll(page || 1)
            .then((result) => {
                setProgram((state) => result.data.sort((a, b) => a.Aircraft.localeCompare(b.Aircraft)) || []);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const onAdd = (newData) => {
        // setProgram((state) => [
        //     {
        //         ID: newData.studentNo,
        //         Name: (newData.studentFirstName + ' ' + newData.studentMidName + ' ' + newData.studentLastName).replace(
        //             '  ',
        //             ' '
        //         ),
        //         DoB: newData.studentDoB,
        //         PoB: newData.studentPoB,
        //         Mail: newData.studentEmail,
        //         Phone: newData.studentPhone,
        //     },
        //     ...state,
        // ]);
    };

    //Open and close the input form
    const toggleModal = () => setShowModal(!showModal);
    
    //Provides the start of the link for the details
    const detailsTo = '/program/details/';

    return (
        <div className={css.main}>
            <div>
                <Table data={programs} detailsTo={detailsTo} />
            </div>
            {/* <div>
                <div>
                    <button onClick={toggleModal} className={css.button}>
                        +
                    </button>
                    
                </div>
                <></>
            </div> */}
        </div>
    );
}

export default ProgramOverview;


// <ModalForm showModal={showModal}>
//                        {/* <AddNewStudent data={programs} onAdd={onAdd} toggleModal={toggleModal} /> */}
//                    </ModalForm>